import { isEqual } from "lodash";
import { JsonPatchOperation } from "_shared/_api/attorney-hub-api-service";
import Team from "marketplace/teams/team";

function compareAndPush(
  payload: JsonPatchOperation[],
  updated: Team,
  original: Team,
  key: "isVisible",
): void {
  if (updated[key] !== original[key]) {
    payload.push({ op: "replace", path: `/${key}`, value: updated[key] });
  }
}

function profileCompareAndPush(
  payload: JsonPatchOperation[],
  updated: Team,
  original: Team,
  key: "name" | "description",
): void {
  if (updated.profile[key] !== original.profile[key]) {
    payload.push({ op: "replace", path: `/${key}`, value: updated.profile[key] });
  }
}

function deepProfileCompareAndPush(
  payload: JsonPatchOperation[],
  updated: Team,
  original: Team,
  key: "categories",
): void {
  if (!isEqual(updated.profile[key], original.profile[key])) {
    payload.push({ op: "replace", path: `/${key}`, value: updated.profile[key] });
  }
}

export function buildUpdateMarketplaceTeamPayload(
  originalTeam: Team,
  updatedTeam: Team,
): JsonPatchOperation[] {
  const payload: JsonPatchOperation[] = [];

  profileCompareAndPush(payload, updatedTeam, originalTeam, "name");
  profileCompareAndPush(payload, updatedTeam, originalTeam, "description");

  const originalCategories = originalTeam.profile.categories ?? [];
  const updatedCategories = updatedTeam.profile.categories ?? [];
  const areCategoriesDifferent =
    originalCategories.length !== updatedCategories.length ||
    originalCategories.some((cat) => !updatedCategories.includes(cat)) ||
    updatedCategories.some((cat) => !originalCategories.includes(cat));

  if (areCategoriesDifferent && (originalCategories.length > 0 || updatedCategories.length > 0)) {
    deepProfileCompareAndPush(payload, updatedTeam, originalTeam, "categories");
  }

  compareAndPush(payload, updatedTeam, originalTeam, "isVisible");

  return payload;
}
